import { HttpService, HttpServiceResponse } from "../shared";
import { SSProfile } from "./ssProfiles.types";
import { Service } from "../settings";

interface GetSSProfileResponse {
  profiles: SSProfile[];
}

interface UpdatePayload {
  [Service.SubscriberSafety]: boolean;
}

type UpdatePayloadKey = keyof UpdatePayload;
interface UpdateSSProfileResponse {
  successful: {
    field: UpdatePayloadKey;
    value: UpdatePayload[UpdatePayloadKey];
  }[];
  status: string;
}

export type UpdateSSProfilePayload = Partial<UpdatePayload>;

export class SSProfilesProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/ssm/ss`;
  }

  public get(
    subscriberId: string
  ): Promise<HttpServiceResponse<GetSSProfileResponse>> {
    return this.http.get(`${this.url}/${subscriberId}`);
  }

  public update(
    subscriberId: string,
    profileName: string,
    changedFields: UpdateSSProfilePayload
  ): Promise<HttpServiceResponse<UpdateSSProfileResponse>> {
    return this.http.patch(
      `${this.url}/${subscriberId}/profile/${profileName}`,
      changedFields
    );
  }
}
